import { combineReducers } from 'redux';
import settingsReducer from './settings/reducer';
import channelReducer from './channel/reducer';
import queryByStoreReducer from './query-by-store/reducer';
import organizationUnitsReducer from './organizationUnits/reducer';
import libraryReducer from './library/reducer';
import countriesReducer from './countries/reducer';
import statesReducer from './states/reducer';
import websitesReducer from './websites/reducer';
import themeReducer from './theme/reducer';
import websiteCardsReducer from './websiteCards/reducer';
import userProfileReducer from './userProfile/reducer';
import bookingsReducer from './bookings/reducer';
import leadsReducer from './leads/reducer';
import agentsReducer from './agents/reducer';
import regionsReducer from './route-management/regions/reducer';
import routesReducer from './route-management/routes/reducer';
import routePointsReducer from './route-management/route-points/reducer';
import zonesReducer from './zones/reducer';
import rateCardsReducer from './rate-cards/reducer';
import cmsSettingsReducer from './cmsSettings/reducer';
import ordersReducer from './orders/reducer';
import quotesReducer from './quotes/reducer';
import razorpayReducer from './razporpay/reducer';
import addPaymentReducer from './addPayment/reducer';
import shippingTypesReducer from './shippingTypes/reducer';
import transportersReducer from './transporters/reducer';
import vehiclesReducer from './vehicles/reducer';
import categoriesReducer from './categories/reducer';
import productTypesReducer from './product-types/reducer';
import productsReducer from './products/reducer';
import variantsReducer from './variants/reducer';
import serviceabilitiesReducer from './serviceabilities/reducer';
import assistanceProgramsReducer from './assistance-programs/reducer';
import socialProfilesReducer from './social-profiles/reducer';
import blogPostsReducer from './blog-posts/reducer';
import blogRequestsReducer from './blog-requests/reducer';
import ticketsReducer from './tickets/reducer';
import employeesReducer from './employees/reducer';
import departmentsReducer from './departments/reducer';
import payrollsReducer from './payrolls/reducer';
import designationsReducer from './designations/reducer';
import websiteReducer from './website/reducer';
import taxLedgersReducer from './tax-ledgers/reducer';
import taxProvidersReducer from './tax-providers/reducer';
import taxSettingsReducer from './tax-settings/reducer';
import payoutsReducer from './payouts/reducer';
import termsLibrariesReducer from './terms-libraries/reducer';
import branchesReducer from './branches/reducer';
import storesReducer from './stores/reducer';
import productionPlantsReducer from './production-plants/reducer';
import warehousesReducer from './ware-houses/reducer';
import locationsReducer from './locations/reducer';
import usersReducer from './users/reducer';
import rolesReducer from './roles/reducer';
import accessControlsReducer from './access-controls/reducer';
import pagesReducer from './pages/reducer';
import accountsReducer from './accounts/reducer';
import accountTypesReducer from './account-types/reducer';
import contactsReducer from './contacts/reducer';
import languagesReducer from './languages/reducer';
import currenciesReducer from './currencies/reducer';
import membershipsReducer from './memberships/reducer';
import membershipTypesReducer from './membership-types/reducer';
import membershipMemberMappingsReducer from './membership-member-mappings/reducer';
import dbnpReducer from './dbnp/reducer';
import dbnpMappingsReducer from './dbnp-mappings/reducer';
import orgRegistriesReducer from './org-registries/reducer';
import emailAccountsReducer from './email-accounts/reducer';
import paymentMethodsReducer from './payment-methods/reducer';
import batchLogsReducer from './batch-logs/reducer';
import logsReducer from './logs/reducer';
import systemInformationsReducer from './system-informations/reducer';
import ParsingRulesReducer from './parsing-rules/reducer';
import customersReducer from './customers/reducer';
import jobsReducer from './jobs/reducer';
import tasksReducer from './tasks/reducer';
import userReducer from './user/reducer';
import organizationsReducer from './organizations/reducer';
import addressBooksReducer from './address-books/reducer';
import timeZonesReducer from './time-zone/reducer';
import uploadFilesReducer from './upload-files/reducer';
import productionUnitsReducer from './production-units/reducer';
import collectionPointsReducer from './collection-points/reducer';
import servicesReducer from './services/reducer';
import globalsReducer from './global/reducer';
import eApplicationsReducer from './e-applications/reducer';
import deliveryDatesReducer from './delivery-dates/reducer';
import measureDimensionsReducer from './measure-dimensions/reducer';
import measureWeightsReducer from './measure-weights/reducer';
import taxCategoriesReducer from './tax-categories/reducer';
import cancelReasonsReducer from './cancel-reasons/reducer';
import fulfillmentProvidersReducer from './fulfillment-providers/reducer';
import shippingProvidersReducer from './shipping-providers/reducer';
import tenantDomainsReducer from './tenant-domains/reducer';
import tagsReducer from './tags/reducer';
import vendorsReducer from './vendors/reducer';
import pinCodesReducer from './pin-codes/reducer';
import pickupPointsReducer from './pickup-points/reducer';
import networksReducer from './dbaas/networks/reducer';
import pushNotificationsReducer from './push-notification/reducer';
import shippingModesReducer from './logistics/transport/shipping-modes/reducer';
import blogPostFilesReducer from './blog-post-files/reducer';
import newsletterReducer from './news-letters/reducer';
import newsletterFilesReducer from './news-letters-files/reducer';
import announcementsReducer from './announcements/reducer';
import helpTopicFilesReducer from './help-topics-files/reducer';
import helpTopicsReducer from './help-topics/reducer';
import influencersReducer from './influencers/reducer';
import { tenantFunctions } from './tenant-functions/action';
import tenantFunctionsReducer from './tenant-functions/reducer';
import edocsReducer from './e-docs/reducer';
import templatesReducer from './templates/reducer';
import agentLocationTrackersReducer from './agent-location-tracker/reducer';
import externalAuthenticationsReducer from './external-authentications/reducer';
import scheduledTasksReducer from './scheduled-tasks/reducer';
import convertFileReducer from './convert-file/reducer';
import ticketActivitiesReducer from './ticket-activities/reducer';
import serviceRequestsReducer from './service-requests/reducer';
import evaluationsReducer from './evaluations/reducer';
import projectsReducer from './projects/reducer';
import subCategoriesReducer from './sub-categories/reducer';
import accountCategoriesReducer from './account-categories/reducer';
import accountLedgersReducer from './account-ledgers/reducer';
import accountUsersReducer from './account-users/reducer';
import brandMappingsReducer from './brand-mappings/reducer';
import sectionsReducer from './sections/reducer';
import metaTokensReducer from './meta-token/reducer';
import programsReducer from './programs/reducer';
import subscriptionsReducer from './subscriptions/reducer';
import dbaasSubscriptionsReducer from './dbaas-subscriptions/reducer';
import routerReducer from './router/reducer';
import smsConfigurationsReducer from './sms-configuration/reducer';
import sectionTemplatesReducer from './section-templates/reducer';
import discountsReducer from './policy/merchandising/discounts/reducer';
import policyCollectionsReducer from './organization/collections/reducer';
import accountWebPagesReducer from './web-pages/reducer';
import dbasReducer from './dbas/reducer';
import rewardPointsReducer from './policy/merchandising/reward-points/reducer';
import deliveriesReducer from './shipment/deliveries/reducer';
import globalSettingsReducer from './global-settings/reducer';

const appReducer = combineReducers({
	settings: settingsReducer,
	theme: themeReducer,
	user: userReducer,
	channel: channelReducer,
	uploadFiles: uploadFilesReducer,
	queryByStore: queryByStoreReducer,
	organizationUnits: organizationUnitsReducer,
	library: libraryReducer,
	countries: countriesReducer,
	states: statesReducer,
	addressBooks: addressBooksReducer,
	websites: websitesReducer,
	websiteCards: websiteCardsReducer,
	userProfile: userProfileReducer,
	bookings: bookingsReducer,
	leads: leadsReducer,
	quotes: quotesReducer,
	orders: ordersReducer,
	agents: agentsReducer,
	agentLocationTrackers: agentLocationTrackersReducer,
	//Route Management Start
	regions: regionsReducer,
	routes: routesReducer,
	routePoints: routePointsReducer,
	zones: zonesReducer,
globalSettings: globalSettingsReducer,
	//Route Management End
	rateCards: rateCardsReducer,
	cmsSettings: cmsSettingsReducer,
	razporpay: razorpayReducer,
	addPayment: addPaymentReducer,
	shippingTypes: shippingTypesReducer,
	transporters: transportersReducer,
	vehicles: vehiclesReducer,
	categories: categoriesReducer,
	productTypes: productTypesReducer,
	products: productsReducer,
	variants: variantsReducer,
	serviceabilities: serviceabilitiesReducer,
	assistancePrograms: assistanceProgramsReducer,
	//CMS Start
	sectionTemplates: sectionTemplatesReducer,
	tenantFunctions: tenantFunctionsReducer,
	eDocs: edocsReducer,
	templates: templatesReducer,
	socialProfiles: socialProfilesReducer,
	blogPosts: blogPostsReducer,
	blogPostsFiles: blogPostFilesReducer,
	newsletters: newsletterReducer,
	newsletterFiles: newsletterFilesReducer,
	blogRequests: blogRequestsReducer,
	influencers: influencersReducer,
	helpTopics: helpTopicsReducer,
	announcements: announcementsReducer,
	helpTopicsFiles: helpTopicFilesReducer,
	discounts:discountsReducer,
	policyCollections:policyCollectionsReducer,
	accountWebPages:accountWebPagesReducer,
	dbas:dbasReducer,
	rewardPoints: rewardPointsReducer,
	deliveries: deliveriesReducer,
	//CMS End
	tickets: ticketsReducer,
	ticketActivities: ticketActivitiesReducer,
	employees: employeesReducer,
	departments: departmentsReducer,
	payrolls: payrollsReducer,
	designations: designationsReducer,
	website: websiteReducer,
	taxLedgers: taxLedgersReducer,
	taxProviders: taxProvidersReducer,
	taxSettings: taxSettingsReducer,
	payouts: payoutsReducer,
	termsLibraries: termsLibrariesReducer,
	branches: branchesReducer,
	stores: storesReducer,
	productionPlants: productionPlantsReducer,
	warehouses: warehousesReducer,
	locations: locationsReducer,
	users: usersReducer,
	roles: rolesReducer,
	externalAuthentications: externalAuthenticationsReducer,
	accessControls: accessControlsReducer,
	pages: pagesReducer,
	accounts: accountsReducer,
	accountTypes: accountTypesReducer,
	contacts: contactsReducer,
	languages: languagesReducer,
	currencies: currenciesReducer,
	memberships: membershipsReducer,
	membershipTypes: membershipTypesReducer,
	membershipMemberMappings: membershipMemberMappingsReducer,
	dbnp: dbnpReducer,
	dbnpMappings: dbnpMappingsReducer,
	orgRegistries: orgRegistriesReducer,
	emailAccounts: emailAccountsReducer,
	paymentMethods: paymentMethodsReducer,
	batchLogs: batchLogsReducer,
	logs: logsReducer,
	systemInformations: systemInformationsReducer,
	parsingRules: ParsingRulesReducer,
	customers: customersReducer,
	jobs: jobsReducer,
	tasks: tasksReducer,
	organizations: organizationsReducer,
	timeZones: timeZonesReducer,
	collectionPoints: collectionPointsReducer,
	productionUnits: productionUnitsReducer,
	services: servicesReducer,
	globals: globalsReducer,
	eApplications: eApplicationsReducer,
	deliveryDates: deliveryDatesReducer,
	measureDimensions: measureDimensionsReducer,
	measureWeights: measureWeightsReducer,
	taxCategories: taxCategoriesReducer,
	fulfillmentProviders: fulfillmentProvidersReducer,
	shippingProviders: shippingProvidersReducer,
	tenantDomains: tenantDomainsReducer,
	cancelReasons: cancelReasonsReducer,
	tags: tagsReducer,
	vendors: vendorsReducer,
	pinCodes: pinCodesReducer,
	pickupPoints: pickupPointsReducer,
	networks: networksReducer,
	pushNotifications: pushNotificationsReducer,
	shippingModes: shippingModesReducer,
	scheduledTasks: scheduledTasksReducer,
	convertFile: convertFileReducer,
	serviceRequests: serviceRequestsReducer,
	evaluations: evaluationsReducer,
	projects: projectsReducer,
	subCategories: subCategoriesReducer,
	accountCategories: accountCategoriesReducer,
	accountLedgers: accountLedgersReducer,
	accountUsers: accountUsersReducer,
	brandMappings: brandMappingsReducer,
	sections: sectionsReducer,
	metaTokens: metaTokensReducer,
	programs: programsReducer,
	subscriptions: subscriptionsReducer,
	dbaasSubscriptions: dbaasSubscriptionsReducer,
	router: routerReducer,
	smsConfigurations: smsConfigurationsReducer,
});

const rootReducer = (state: any, action: any) => {

	return appReducer(state, action);
};

export default rootReducer;
